
const ProgressStepper = () => {
  return (
    <div className="my-2 flex justify-between items-center space-x-2">
      {/* Step 1 - Completed */}
      <div className="flex items-center">
        <div className="w-4 h-4 bg-blue-500 rounded-full border-2 border-blue-500" />
        <div className="w-[160px] h-1 bg-blue-500" />
      </div>

      {/* Step 2 - Current */}
      <div className="flex items-center">
        <div className="w-4 h-4 border-2 border-blue-500 rounded-full flex items-center justify-center">
          <div className="w-2 h-2 bg-blue-500 rounded-full" />
        </div>
        <div className="w-[180px] h-1 border-t-2 border-dashed border-gray-400" />
      </div>

      {/* Step 3 - Incomplete */}
      <div className="w-4 h-4 bg-gray-400 rounded-full" />
    </div>
  );
};

export default ProgressStepper;
